// extracted by mini-css-extract-plugin
export default {"LoginView":"style_LoginView__ChZSy","MiddleRow":"style_MiddleRow__znyce","AdvertisementRow":"style_AdvertisementRow__iQurL"};